(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-module-c"] && !Shopify.designMode) return;
  try {
    
    function scrollToHash(hash) {
        if (!hash) return false;

        const tryScrollToTarget = () => {
            const target = document.getElementById(hash) || document.querySelector(`[id^="${hash}-"]`);
            if (target) {
                const offset = parseInt(target.dataset?.scrollOffset || 0, 10);
                const targetTop = target.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({ top: targetTop, behavior: 'smooth' });
                return true;
            }
            return false;
        };

        // Try immediately
        if (!tryScrollToTarget()) {
            let retries = 0;
            const interval = setInterval(() => {
                if (tryScrollToTarget() || retries > 20) clearInterval(interval);
                retries++;
            }, 200);
        }
        return true;
    }

    // Scroll on page load if hash exists
    window.addEventListener('load', () => {
        const hash = window.location.hash.replace('#', '');
        scrollToHash(hash);
    });

    // Attach smooth scroll to all links with hash href
    document.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault(); // Prevent default jump
            const hash = link.getAttribute('href').replace('#', '');
            scrollToHash(hash);
            // Update URL without jumping
            history.pushState(null, null, `#${hash}`);
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosto-product"] && !Shopify.designMode) return;
  try {
    
  function loadNostoRecommendations(products, result_id) {
    for(let i = 0; i < products.length; i++) {
      const nostoElm = document.getElementById("nosto-recs");
      let productURL = new URL(products[i].url);

      productURL.searchParams.set('ns_ref', result_id);
      productURL.searchParams.set('ns_reftype', 'api');

      let productCard = `
        <div class="item product-grid-item">
          <a class="product-image-wrapper" href="${productURL}">
            <div class="product-link">
              <img src="${products[i].image_url}"/>
            </div>
            <div class="product-info-wrapper">
              <p class="product-name">${products[i].name}</p>
              <div class="price-and-shades">
                <p>From ${products[i].list_price_text}</p>
                <div class="divider"></div>
                <p>${products[i].skus.length} Styles available</p>
              </div>
            </div>
          </a>
        </div>`;
      nostoElm.innerHTML += productCard;
    }
  }

  let placement_id = document.getElementById('nosto_placement_id').innerHTML;
  
  const productRecId = document.querySelector('.product-recommendations').dataset.productRecId;
  nostojs(api => {
    api
      .createRecommendationRequest()
      .setProducts([{product_id: productRecId}])
      .setResponseMode("JSON_ORIGINAL")
      .addElements([placement_id])
      .load()
      .then(response => {
        // console.log({NostoRecommendations: response.recommendations[placement_id]});
        const {products, result_id} = response.recommendations[placement_id];
        loadNostoRecommendations(products, result_id);
      })
      .catch(err => {
        console.log({Nosto_Error: err});
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-guides"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
    if (event.target.tagName === 'SUMMARY' && !event.target.parentElement.hasAttribute('open')) {
        var openDetails = document.querySelectorAll('details[open]');
        openDetails.forEach(function(details) {
            details.removeAttribute('open');
        });
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-module-e"] && !Shopify.designMode) return;
  try {
    
const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
    .then(response => response.text())
    .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;

            window.ORW.lazyload && window.ORW.lazyload.update();
        }
    })
    .catch(e => {
        console.error(e);
    });
};

const productRecommendationsSection = document.querySelector('.product-recommendations');
const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-media-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;
    var container = details.closest('[data-smt-faq]');
    if (!container) return;
    if (details.hasAttribute('open')) return;
    var openItems = container.querySelectorAll('details[open]');
    openItems.forEach(function (item) {
        if (item !== details) item.removeAttribute('open');
    });
});

  } catch(e) { console.error(e); }
})();
})();
